import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const configurations = {
  id: "configurations",
  title: "configurations",
  type: "group",
  children: [
    {
      id: "public-calendar",
      title: "Add Public Calendar",
      type: "item",
      url: "/configurations/public-calendar",
      icon: CalendarMonthIcon,
      breadcrumbs: false,
      guardName: "SetPublicCalendarUrlAdmin"
    }
  ]
};

// const item = utilities?.children

export default configurations;
